import { Dispatch, SetStateAction, useEffect, useState } from 'react'

type Props = {
  countdownSeconds: string
  isCounting: boolean
  setIsCounting: Dispatch<SetStateAction<boolean>>
  onGetOtpCode?: () => void
  disabled?: boolean
}

export const CountdownButton = ({
  countdownSeconds,
  isCounting,
  setIsCounting,
  onGetOtpCode,
  disabled = false,
}: Props) => {
  const countdownSecondsToNumber = Number(countdownSeconds) || 60
  const [leftSeconds, setLeftSeconds] = useState<number>(0)

  const otpBtnLabel = isCounting ? `取得驗證碼（${leftSeconds}s）` : '取得驗證碼'
  const handleGetOtpCode = () => {
    setLeftSeconds(countdownSecondsToNumber)
    setIsCounting(true)
    onGetOtpCode?.()
  }

  useEffect(() => {
    setLeftSeconds(countdownSecondsToNumber)
  }, [countdownSecondsToNumber])

  useEffect(() => {
    if (!isCounting) return

    const timer = setInterval(() => {
      setLeftSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          setIsCounting(false)
          return countdownSecondsToNumber
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [isCounting, countdownSecondsToNumber, setIsCounting])

  return (
    <button type="button" className="btn btn-light" onClick={handleGetOtpCode} disabled={isCounting || disabled}>
      {otpBtnLabel}
    </button>
  )
}
